import { render, staticRenderFns } from "./AreaEmbargadaGoias.vue?vue&type=template&id=505befb3&lang=pug"
import script from "./AreaEmbargadaGoias.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaGoias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports